import { yup } from '../../../shared/utils/yup';
import { IPortalSection } from '../../section/types';

const yupSection: Partial<Record<keyof IPortalSection, yup.BaseSchema>> = {};

export const sectionSchema = yup.object({}).shape(yupSection);
